import React from 'react';
import './App.scss';
import Header from "./auth/Header";
import Footer from "./auth/Footer";
import IndexRoute from "./routes/IndexRoute";
import { TonConnectUIProvider } from '@tonconnect/ui-react';

function App() {
    return (
        <TonConnectUIProvider manifestUrl="https://cryptolotto777.com/tonconnect-manifest.json">
            <div className="App">
                <Header />
                <IndexRoute />
                <div style={{ width: '100%', position: 'fixed', bottom: 0, zIndex: 2 }}>
                    <Footer />
                </div>
            </div>
        </TonConnectUIProvider>
    );
}

export default App;
